import { writable } from 'svelte/store';

export const activeSectionId = writable();
